import { createApp } from 'vue'
import App from '../App.vue'
import { createWebHistory, createRouter } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: [{ path: '/:uni?', component: App }],
})

createApp(App)
    .use(router)
    .mount('#app');
